/**
 * @Email : azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @jobTittle: Full Stack Developer
 *
 */


import {STATUS_MODEL} from "../../../../../enums/statusEnum";
import {CRITERIA_MODEL} from "../../../../../components/table/Model/TableModel";
import {DATA_TYPE_MODEL, ORDER_MODEL, SEARCH_OPERATION_MODEL} from "../../../../Modals/Model/Model";
import {fieldModelName} from "../../../../../enums/fieldModelEnum";

export const StaticMsg = {
    PENDING_TO_UPLOAD_INFORMATION: {
        id: STATUS_MODEL.PENDING_TO_UPLOAD_INFORMATION,
        tittle : 'pending_review',
        toast: "pending_to_upload_information",
        classCard: "card-shades-150-50",
        fontColor: "font-color-shades-700",
        infoColor: "icon-color-shades-700",
    },
    PENDING_REVIEW: {
        id: STATUS_MODEL.PENDING_REVIEW,
        tittle : 'pending_review',
        toast: "pending_review",
        classCard: "card-shades-150-50",
        fontColor: "font-color-shades-700",
        infoColor: "icon-color-shades-700",
    },
    APPROVED: {
        id: STATUS_MODEL.APPROVED,
        tittle : 'approved',
        toast: "approved_by",
        classCard: "card-success-150-50",
        fontColor: "font-color-success-700",
        infoColor: "icon-color-success-700",
    },
    REJECTED: {
        id: STATUS_MODEL.REJECTED,
        tittle : 'rejected',
        toast: "rejected_by",
        classCard: "card-error-code-150-50",
        fontColor: "font-color-error-600",
        infoColor: "icon-color-error-code-700",
    },
    DENIED: {
        id: STATUS_MODEL.DENIED,
        tittle : 'denied',
        toast: "denied_by",
        classCard: "card-error-code-150-50",
        fontColor: "font-color-error-600",
        infoColor: "icon-color-error-code-700",
    },
    CANCELED: {
        id: STATUS_MODEL.CANCELED,
        tittle : 'canceled',
        toast: "canceled_by_admin",
        classCard: "card-error-code-150-50",
        fontColor: "font-color-error-600",
        infoColor: "icon-color-error-code-700",
    },
    CHANGES_REQUESTED: {
        id: STATUS_MODEL.CHANGES_REQUESTED,
        tittle : 'changes_requested',
        toast: "changes_requested_documentation",
        classCard: "card-warning-150-50",
        fontColor: "font-color-warning-700",
        infoColor: "icon-color-warning-700",
    },
    UNKNOWN: {
        id: -1,
        titleTrans: "unknown_status",
        displayTitle: "unknown_status",
        classCard: "card-shades-150-50",
        fontColor: "font-color-shades-700",
        infoColor: "icon-color-shades-700",
    },
};


export const INVITATION_REQUEST_DOCUMENTATION_DECISION_MODEL = {
    statusReason: null,
    option: '',
    invitationId: null,

    toRegister: function () {
        return {
            statusReason: this.statusReason,
            option: this.option,
            invitationId: this.invitationId,

        };
    },

    isValid: function () {
        return this.statusReason != null && this.statusReason.trim() !== "";
    }
};

/**
 * Builds a filter criteria for searching by the current user (visitor).
 * @returns {Object} Criteria object for filtering by visitor ID.
 */
export const approvalStatusCriteria = (option) => {
    return CRITERIA_MODEL.set({
        "dataOption": SEARCH_OPERATION_MODEL.AND,
        "fieldType": DATA_TYPE_MODEL.LONG,
        "filterKey": fieldModelName.approvalStatus,
        "operation": SEARCH_OPERATION_MODEL.EQ,
        "sort": ORDER_MODEL.ASC,
        "table": option,
        "values": [STATUS_MODEL.APPROVED]
    });
}

/**
 * Retrieves the UI configuration associated with a status identifier.
 *
 * Behavior:
 * - Searches all available status configurations defined in `StaticMsg`.
 * - Returns the matching configuration object for the provided status ID.
 * - Returns `StaticMsg.UNKNOWN` when no matching status configuration exists.
 *
 * Configuration includes:
 * - Translation keys
 * - Toast messages
 * - Card styles
 * - Font colors
 * - Icon colors
 *
 * @param {number} statusId - Status identifier to search.
 *
 * @returns {Object} Matching status configuration object
 * or the default unknown status configuration.
 */
export const getStatusConfig = (statusId) => {
    const allStatusConfigs = Object.values(StaticMsg);
    return allStatusConfigs.find(status => status.id === statusId) || StaticMsg.UNKNOWN;
};
